import React from 'react'
import { useHistory } from 'react-router'

// utils
import { createJobDayCards } from './JobDaysForJob.collection.utils'

// graphql
import { useQuery } from '@apollo/client'
import { GET_JOB_DAYS_FOR_FOREMAN_FOR_JOB } from '../../../../../graphql/job/job.queries'

// components
import FourSectionCardListItem from '../../../../../components/collections/FourSectionCardListItem/FourSectionCardListItem.component'

export default function JobDaysForJob({ jobId }) {
    const history = useHistory()

    let cards = []

    const { data } = useQuery(GET_JOB_DAYS_FOR_FOREMAN_FOR_JOB, { 
        variables: { id: jobId }
    })

    if(data && data.jobDaysForForemanForJob) {
        cards = [...createJobDayCards(data.jobDaysForForemanForJob)]
    }

    return (<div className='job-days-for-job'>

        {
            cards.map(card => {
                return (<FourSectionCardListItem 
                    mainTitle={card.date}
                    subTitle={card.startTime}
                    leftData={[`${card.numCrewMembers} Crew Member${card.numCrewMembers !== 1 ? 's' : ''}`]}
                    rightData={null}
                    onClick={() => history.push(`/schedule/details/${card.id}`)} 
                />)
            })
        }
        
    </div>)
}